import * as grid from './grid';
import colors, { getColorFromVar } from './colors';
import * as buttons from './buttons';
import * as typography from './typography';
import * as inputs from './inputs';
import * as header from './header';
import * as productTags from './productTags';
import { DefaultTheme } from 'styled-components';

const theme: DefaultTheme = {
  grid,
  colors,
  buttons,
  typography,
  inputs,
  header,
  productTags,
  getColor: (key: string, level: number | undefined = undefined) =>
    getColorFromVar(theme, key, level),
};

export type Theme = typeof theme;

export default theme;
